var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52ZM39.2545 15.7455C38.7771 15.2682 38.1296 15 37.4545 15H14.5455C13.8704 15 13.2229 15.2682 12.7455 15.7455C12.2682 16.2229 12 16.8704 12 17.5455V35.3636C12 36.0387 12.2682 36.6862 12.7455 37.1635C13.2229 37.6409 13.8704 37.9091 14.5455 37.9091H37.4545C38.1296 37.9091 38.7771 37.6409 39.2545 37.1635C39.7318 36.6862 40 36.0387 40 35.3636V17.5455C40 16.8704 39.7318 16.2229 39.2545 15.7455ZM37.2725 19.1689C37.5168 19.2345 37.7252 19.3945 37.8516 19.6136C37.9671 19.8135 38.0062 20.0485 37.9618 20.275C37.9173 20.5015 37.7923 20.7042 37.6098 20.8456L37.5016 20.9182L26.5944 27.2156C26.4413 27.3336 26.2561 27.4024 26.0632 27.4128C25.8703 27.4233 25.6787 27.3749 25.5138 27.2742L14.5136 20.922C14.3043 20.801 14.1488 20.605 14.0783 20.3738C14.0079 20.1425 14.0279 19.8931 14.1342 19.6759C14.2405 19.4588 14.4252 19.2901 14.6511 19.2039C14.877 19.1177 15.1271 19.1204 15.3511 19.2115L15.4682 19.2687L26.0038 25.3511L36.5484 19.2636C36.7676 19.1373 37.0281 19.1032 37.2725 19.1689Z",
    fill: "#518BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9c7a81a4a8099f8430764daa1143a2d6.svg";
export { ForwardRef as ReactComponent };